import React from "react";

import { MY_ACTIVITY_TITLE } from "../constants";
import {
  ItemText,
  ListTitle,
  MenuList,
  MultiLevelMenu
} from "../MultiLevelMenu";

const MyActivity = () => (
  <MultiLevelMenu title={MY_ACTIVITY_TITLE}>
    <ListTitle>{MY_ACTIVITY_TITLE}</ListTitle>
    <MenuList isSubMenu>
      <li>
        <ItemText href="/lists?type=sale">Sales</ItemText>
      </li>
      <li>
        <ItemText href="/lists?type=rental">Rentals</ItemText>
      </li>
      <li>
        <ItemText href="/lists?type=building">Buildings</ItemText>
      </li>
      <li>
        <ItemText href="/my/saved_searches">Saved Searches</ItemText>
      </li>
    </MenuList>
  </MultiLevelMenu>
);

MyActivity.propTypes = {};

MyActivity.defaultProps = {};

export default MyActivity;
